import { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Table } from 'reactstrap';
import { CustomerDataColumn } from 'types';
import SwitchInput from 'views/Widgets/Inputs/SwitchInput';

interface CustomerColumnsAvailabilityTableProps {
  ownedColumns: CustomerDataColumn[];
  value: Record<string, { available: boolean }>;
  onChange: (next: Record<string, { available: boolean }>) => void;
}

const CustomerColumnsAvailabilityTable: FC<
  CustomerColumnsAvailabilityTableProps
> = ({ ownedColumns, value, onChange }) => {
  const handleToggle = useCallback(
    (columnKey: string, available: boolean) => {
      if (available) {
        if (value[columnKey]) return;
        onChange({ ...value, [columnKey]: { available: true } });
      } else {
        if (!value[columnKey]) return;
        const { [columnKey]: _removed, ...rest } = value;
        onChange(rest);
      }
    },
    [onChange, value]
  );

  return (
    <Table responsive size="sm" className="card-table mb-3">
      <thead>
        <tr>
          <th>
            <div className="text-muted">
              <FormattedMessage
                id="app.views.widgets.dashboards.calibration_dashboard.customer_columns_availability.column"
                defaultMessage="Column"
              />
            </div>
          </th>
          <th style={{ width: '6rem' }}>
            <div className="text-muted">
              <FormattedMessage
                id="app.views.widgets.dashboards.calibration_dashboard.customer_columns_availability.available"
                defaultMessage="Available"
              />
            </div>
          </th>
        </tr>
      </thead>
      <tbody className="list">
        {ownedColumns.map((col) => (
          <tr key={col.key}>
            <td>{col.label}</td>
            <td>
              <SwitchInput
                name={`customer-column-available-${col.key}`}
                value={!!value[col.key]}
                onChange={(checked: boolean) => handleToggle(col.key, checked)}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default CustomerColumnsAvailabilityTable;
